<div class="bg-m1 flex h-full cursor-default flex-col">
  <div
    class="flex h-2 flex-1 flex-row items-center justify-center overflow-y-auto"
  >
    <form
      class="flex w-96 flex-col py-[50px]"
      [formGroup]="setPasswordForm"
      (ngSubmit)="setPassword()"
    >
      <div class="text-s2 text-center text-2xl font-semibold">{{
        pageTitle
      }}</div>
      <input
        spellcheck="false"
        data-cy="updatePasswordNewPasswordInput"
        class="form-input border-s3 focus:border-m600 mt-9 rounded"
        [ngClass]="{
          'border-r600':
            setPasswordForm.controls['newPassword'].invalid &&
            setPasswordForm.controls['newPassword'].touched
        }"
        type="password"
        formControlName="newPassword"
        placeholder="New Password"
      />
      <m-validation
        [control]="setPasswordForm.controls['newPassword']"
      ></m-validation>

      <input
        spellcheck="false"
        data-cy="updatePasswordConfirmPasswordInput"
        class="form-input border-s3 focus:border-m600 mt-1 rounded"
        [ngClass]="{
          'border-r600':
            setPasswordForm.controls['confirmPassword'].invalid &&
            setPasswordForm.controls['confirmPassword'].touched
        }"
        type="password"
        formControlName="confirmPassword"
        placeholder="Confirm Password"
      />
      <m-validation
        [control]="setPasswordForm.controls['confirmPassword']"
      ></m-validation>

      <button
        data-cy="updatePasswordSetPasswordButton"
        class="bg-m600 text-m0 mt-1 rounded py-3 text-base font-medium focus:outline-none"
        type="submit"
        >Set Password</button
      >
    </form>
  </div>
</div>
